import {
  HStack,
  Slider,
  SliderFilledTrack,
  SliderThumb,
  SliderTrack,
  Spinner,
  Stack,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import { TouchableOpacity } from "components/common";
import {
  getSelectedSurah,
  setSelectedSurah,
} from "features/apps/non_persist_slice";
import { useTranslation } from "languages";
import React, { memo, useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "tools/store";
import { downloadAudio } from "utils/Helpers";

const AudioPlayer: React.FC = () => {
  const audioRef = useRef<any>(null);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const [currentTime, setCurrentTime] = useState<number>(0);
  const [duration, setDuration] = useState<number>(0);
  const [volume, setVolume] = useState<number>(1); // Default volume at 100%
  const [isBuffering, setBuffering] = useState(true);

  // const toast = useToast();

  const {
    // translation,
    isArabic,
  } = useTranslation();

  const dispatch = useAppDispatch();

  // const audioUrl = "https://server6.mp3quran.net/akdr/001.mp3";

  const [audioUrl, setAudioUrl] = useState<string | undefined>();

  // const userData = useAppSelector(getSession);
  const selectedSurah = useAppSelector(getSelectedSurah);

  // const { data } = useGetBookmarksQuery(userData?.user?.id || 0, {
  //   skip: !userData?.user?.id,
  // });

  // const chechBoomark = () => {
  //   const ind = (data || []).findIndex((it: any) => {
  //     const content = JSON.parse(it?.content);
  //     return (
  //       content.currentSurahNumber === selectedSurah.currentSurahNumber &&
  //       content?.qariDetail?.id === selectedSurah?.qariDetail?.id
  //     );
  //   });

  //   // console.log("=-=-=", ind);

  //   return ind > -1;
  // };

  // console.log("=-=-=-=-=", chechBoomark());

  // const [addBookmark] = useAddBookmarkMutation();

  const togglePlayPause = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleTimeUpdate = () => {
    setCurrentTime(audioRef.current.currentTime);
  };

  const handleLoadedMetadata = () => {
    setDuration(audioRef.current.duration);
  };

  const handleSliderSeek = (val: any) => {
    const seekTime = (val / 100) * duration;
    audioRef.current.currentTime = seekTime;
    setCurrentTime(seekTime);
  };

  const handleVolumeChange = (val: number) => {
    const newVolume = val / 100;
    audioRef.current.volume = newVolume;
    setVolume(newVolume);
  };

  const handlePrevious = async () => {
    const tempList = selectedSurah?.surahList || [];
    const findedIndex = (selectedSurah?.surahList || []).findIndex(
      (it: any) =>
        (it?.number || it?.surahNumber) === selectedSurah?.currentSurahNumber
    );
    if (findedIndex > -1) {
      if (findedIndex !== 0) {
        const prevItem = tempList[findedIndex - 1];
        const body = {
          ...selectedSurah,
          currentSurahNumber: prevItem?.number || prevItem?.surahNumber,
        };
        dispatch(setSelectedSurah(body));
      }
    }
  };

  const handleNext = async () => {
    const tempList = selectedSurah?.surahList || [];
    const findedIndex = (selectedSurah?.surahList || []).findIndex(
      (it: any) =>
        (it?.number || it?.surahNumber) === selectedSurah?.currentSurahNumber
    );
    if (findedIndex > -1) {
      if (findedIndex < tempList.length - 1) {
        const nextItem = tempList[findedIndex + 1];
        const body = {
          ...selectedSurah,
          currentSurahNumber: nextItem?.number || nextItem?.surahNumber,
        };
        dispatch(setSelectedSurah(body));
      }
    }
  };

  // const handleAddBookmark = () => {
  //   const date = new Date();
  //   if (!chechBoomark()) {
  //     var payload = {
  //       user_id: userData?.user.id,
  //       content: JSON.stringify({ ...selectedSurah, date }),
  //     };
  //     addBookmark(payload)
  //       .then((res) => {
  //         if (res.data && !res.error) {
  //           ShowToast(toast, translation["bookSave"], "success");
  //         }
  //       })
  //       .catch(console.error);
  //   } else {
  //     ShowToast(toast, translation["alreadyBook"], "warning");
  //   }
  // };

  useEffect(() => {
    setIsPlaying(false);
    if (selectedSurah?.currentSurahNumber) {
      const tempUrl = `${
        selectedSurah?.qariDetail?.highestElement?.server
      }${selectedSurah?.currentSurahNumber?.toString().padStart(3, "0")}.mp3`;

      setAudioUrl(tempUrl);

      setTimeout(async () => {
        if (audioRef.current) {
          audioRef.current.load(); // Reload the audio element
          audioRef.current.oncanplay = () => {
            audioRef.current.play(); // Play the new audio
            setIsPlaying(true); // Update the play state
          };
          setCurrentTime(0); // Reset time
          setDuration(0); // Reset duration until metadata loads
        }
      }, 500);
    }
  }, [selectedSurah]);

  useEffect(() => {
    setTimeout(async () => {
      setBuffering(false);
    }, 1000);
  }, []);

  // console.log("==-==", isBuffering);

  const layoutDirection = useBreakpointValue({ base: "column", md: "row" });

  return (
    <Stack
      mx={[2, 10]}
      mt={2}
      h={"full"}
      bgColor={"secondary.900"}
      py={2}
      px={5}
      borderLeftRadius={"xl"}
      borderRightRadius={"xl"}
    >
      {audioUrl && (
        <audio
          ref={audioRef}
          src={audioUrl}
          onTimeUpdate={handleTimeUpdate}
          onLoadedMetadata={handleLoadedMetadata}
          onLoadedData={() => setBuffering(true)}
          onPlaying={() => setBuffering(false)}
        />
      )}

      <HStack w="full" justify={"space-between"}>
        <Stack />
        {/* <TouchableOpacity
          onClick={handleAddBookmark}
          disabled={
            chechBoomark() ||
            !selectedSurah?.currentSurahNumber ||
            !userData?.user
          }
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
          >
            <g id="archive-minus" transform="translate(0.5 0.5)">
              <g
                id="vuesax_linear_archive-minus"
                data-name="vuesax/linear/archive-minus"
              >
                <g id="archive-minus-2" data-name="archive-minus">
                  <path
                    id="Vector"
                    d="M3.86,0A3.869,3.869,0,0,0,0,3.86V17.95c0,1.8,1.29,2.56,2.87,1.69l4.88-2.71a2.118,2.118,0,0,1,1.87,0l4.88,2.71c1.58.88,2.87.12,2.87-1.69V3.86A3.884,3.884,0,0,0,13.5,0Z"
                    transform="translate(3.32 2)"
                    fill={chechBoomark() ? "#bf8d46" : "none"}
                    stroke="#bf8d46"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    stroke-dasharray="0 0"
                  />
                  <path
                    id="Vector-2"
                    data-name="Vector"
                    d="M24,0V24H0V0Z"
                    fill="none"
                    stroke="#bf8d46"
                    stroke-width="1"
                    opacity="0"
                  />
                </g>
              </g>
            </g>
          </svg>
        </TouchableOpacity> */}

        <HStack gap={5} mr={[0, "-220px"]}>
          <TouchableOpacity
            onClick={handlePrevious}
            disabled={!selectedSurah?.currentSurahNumber}
          >
            <svg
              id="previous"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <g id="vuesax_bold_previous" data-name="vuesax/bold/previous">
                <g id="previous-2" data-name="previous">
                  <path
                    id="Vector"
                    d="M24,0V24H0V0Z"
                    transform="translate(24 24) rotate(180)"
                    fill="#bf8d46"
                    opacity="0"
                  />
                  <path
                    id="Vector-2"
                    data-name="Vector"
                    d="M13.4,12.126a2.556,2.556,0,0,1-3.83,2.21l-4.15-2.39-4.15-2.4a2.544,2.544,0,0,1,0-4.41l4.15-2.4L9.575.346a2.553,2.553,0,0,1,3.83,2.21Z"
                    transform="translate(6.836 4.664)"
                    fill="#bf8d46"
                  />
                  <path
                    id="Vector-3"
                    data-name="Vector"
                    d="M0,13.11V.75A.755.755,0,0,1,.75,0,.755.755,0,0,1,1.5.75V13.11a.755.755,0,0,1-.75.75A.755.755,0,0,1,0,13.11Z"
                    transform="translate(3.012 5.07)"
                    fill="#bf8d46"
                  />
                </g>
              </g>
            </svg>
          </TouchableOpacity>

          <TouchableOpacity
            bgColor="#5F4C31"
            h={"50px"}
            w={"50px"}
            align={"center"}
            justify={"center"}
            borderRadius={100}
            onClick={togglePlayPause}
            disabled={!selectedSurah?.currentSurahNumber}
          >
            {isBuffering ? (
              <Spinner />
            ) : (
              <>
                {isPlaying ? (
                  <svg
                    id="pause"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g id="vuesax_bulk_pause" data-name="vuesax/bulk/pause">
                      <g id="pause-2" data-name="pause">
                        <path
                          id="Vector"
                          d="M7.65,1.89C7.65.54,7.08,0,5.64,0H2.01C.57,0,0,.54,0,1.89V16.11C0,17.46.57,18,2.01,18H5.64c1.44,0,2.01-.54,2.01-1.89Z"
                          transform="translate(3 3)"
                          fill="#bf8d46"
                        />
                        <path
                          id="Vector-2"
                          data-name="Vector"
                          d="M7.65,1.89C7.65.54,7.08,0,5.64,0H2.01C.58,0,0,.54,0,1.89V16.11C0,17.46.57,18,2.01,18H5.64c1.44,0,2.01-.54,2.01-1.89Z"
                          transform="translate(13.35 3)"
                          fill="#bf8d46"
                        />
                        <path
                          id="Vector-3"
                          data-name="Vector"
                          d="M24,0V24H0V0Z"
                          fill="#bf8d46"
                          opacity="0"
                        />
                      </g>
                    </g>
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15.812"
                    height="16.822"
                    viewBox="0 0 15.812 16.822"
                  >
                    <path
                      id="Vector"
                      d="M0,4.97C0,.527,3.14-1.264,6.978.946L9.956,2.667l2.977,1.721c3.838,2.21,3.838,5.839,0,8.048L9.956,14.158,6.978,15.88C3.14,18.09,0,16.275,0,11.856V4.97Z"
                      fill="#bf8d46"
                    />
                  </svg>
                )}
              </>
            )}
          </TouchableOpacity>

          <TouchableOpacity
            onClick={handleNext}
            disabled={!selectedSurah?.currentSurahNumber}
          >
            <svg
              id="next"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <g id="vuesax_bold_next" data-name="vuesax/bold/next">
                <g id="next-2" data-name="next">
                  <path
                    id="Vector"
                    d="M24,0V24H0V0Z"
                    transform="translate(24 24) rotate(180)"
                    fill="#bf8d46"
                    opacity="0"
                  />
                  <path
                    id="Vector-2"
                    data-name="Vector"
                    d="M0,12.126a2.556,2.556,0,0,0,3.83,2.21l4.15-2.39,4.15-2.4a2.544,2.544,0,0,0,0-4.41l-4.15-2.4L3.83.346A2.553,2.553,0,0,0,0,2.556Z"
                    transform="translate(3.762 4.664)"
                    fill="#bf8d46"
                  />
                  <path
                    id="Vector-3"
                    data-name="Vector"
                    d="M0,13.11V.75A.755.755,0,0,1,.75,0,.755.755,0,0,1,1.5.75V13.11a.75.75,0,0,1-1.5,0Z"
                    transform="translate(19.488 5.07)"
                    fill="#bf8d46"
                  />
                </g>
              </g>
            </svg>
          </TouchableOpacity>
        </HStack>

        <HStack w={[6, "220px"]} gap={5}>
          {layoutDirection === "row" && (
            <>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="35px"
                height="35px"
                fill="currentColor"
              >
                <path d="M2 16.0001H5.88889L11.1834 20.3319C11.2727 20.405 11.3846 20.4449 11.5 20.4449C11.7761 20.4449 12 20.2211 12 19.9449V4.05519C12 3.93977 11.9601 3.8279 11.887 3.73857C11.7121 3.52485 11.3971 3.49335 11.1834 3.66821L5.88889 8.00007H2C1.44772 8.00007 1 8.44778 1 9.00007V15.0001C1 15.5524 1.44772 16.0001 2 16.0001ZM23 12C23 15.292 21.5539 18.2463 19.2622 20.2622L17.8445 18.8444C19.7758 17.1937 21 14.7398 21 12C21 9.26016 19.7758 6.80629 17.8445 5.15557L19.2622 3.73779C21.5539 5.75368 23 8.70795 23 12ZM18 12C18 10.0883 17.106 8.38548 15.7133 7.28673L14.2842 8.71584C15.3213 9.43855 16 10.64 16 12C16 13.36 15.3213 14.5614 14.2842 15.2841L15.7133 16.7132C17.106 15.6145 18 13.9116 18 12Z" />
              </svg>

              <Slider
                aria-label="slider-ex-2"
                min={0}
                max={100}
                value={volume * 100}
                onChange={handleVolumeChange}
                isDisabled={!selectedSurah?.currentSurahNumber}
              >
                <SliderTrack bg="secondary.900">
                  <SliderFilledTrack bg="primary.300" />
                </SliderTrack>
                <SliderThumb bgColor={"primary.300"} />
              </Slider>
            </>
          )}

          <TouchableOpacity
            onClick={() => downloadAudio(selectedSurah, isArabic)}
            disabled={!selectedSurah?.currentSurahNumber}
          >
            <svg
              id="receive-square"
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              viewBox="0 0 26 26"
            >
              <g
                id="vuesax_outline_receive-square"
                data-name="vuesax/outline/receive-square"
              >
                <g id="receive-square-2" data-name="receive-square">
                  <path
                    id="Vector"
                    d="M14.9,23.292H8.4c-5.885,0-8.4-2.511-8.4-8.4V8.4C0,2.511,2.511,0,8.4,0h6.5c5.885,0,8.4,2.511,8.4,8.4v6.5C23.292,20.781,20.781,23.292,14.9,23.292ZM8.4,1.625c-5,0-6.77,1.772-6.77,6.77v6.5c0,5,1.772,6.77,6.77,6.77h6.5c5,0,6.77-1.772,6.77-6.77V8.4c0-5-1.772-6.77-6.77-6.77Z"
                    transform="translate(1.354 1.354)"
                    fill="#bf8d46"
                  />
                  <path
                    id="Vector-2"
                    data-name="Vector"
                    d="M3.486,4.634.236,1.384A.812.812,0,0,1,1.384.236L4.06,2.911,6.736.236A.812.812,0,0,1,7.884,1.384l-3.25,3.25a.811.811,0,0,1-1.148,0Z"
                    transform="translate(8.94 11.659)"
                    fill="#bf8d46"
                  />
                  <path
                    id="Vector-3"
                    data-name="Vector"
                    d="M0,9.479V.813A.818.818,0,0,1,.813,0a.818.818,0,0,1,.813.813V9.479A.812.812,0,1,1,0,9.479Z"
                    transform="translate(12.188 6.24)"
                    fill="#bf8d46"
                  />
                  <path
                    id="Vector-4"
                    data-name="Vector"
                    d="M.551,1.584A.816.816,0,0,1,.042.555.8.8,0,0,1,1.071.046a19.861,19.861,0,0,0,12.491,0,.812.812,0,1,1,.52,1.538A21.249,21.249,0,0,1,7.311,2.678,21.439,21.439,0,0,1,.551,1.584Z"
                    transform="translate(5.69 17.071)"
                    fill="#bf8d46"
                  />
                  <path
                    id="Vector-5"
                    data-name="Vector"
                    d="M26,0V26H0V0Z"
                    fill="#bf8d46"
                    opacity="0"
                  />
                </g>
              </g>
            </svg>
          </TouchableOpacity>
        </HStack>
      </HStack>

      <HStack w={"full"} gap={5} mt={-2} fontWeight={"bold"}>
        <Text>{formatTime(currentTime)}</Text>
        <Slider
          aria-label="slider-ex-2"
          value={(currentTime / duration) * 100 || 0}
          min={0}
          max={100}
          onChange={handleSliderSeek}
          isDisabled={!selectedSurah?.currentSurahNumber}
        >
          <SliderTrack bg="secondary.950">
            <SliderFilledTrack bg="primary.300" />
          </SliderTrack>
          <SliderThumb bgColor={"primary.300"} />
        </Slider>
        <Text>{formatTime(duration)}</Text>
      </HStack>
    </Stack>
  );
};

const formatTime = (time: any) => {
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60)
    .toString()
    .padStart(2, "0");
  return `${minutes}:${seconds}`;
};

export default memo(AudioPlayer);
